"use client";

import * as React from "react";
import { HireWizardSummaryStep } from "~/components/marketplace/hire-wizard-summary-step";
import type { HireRecommendationsSelection } from "~/lib/marketplace/hire-recommendations-pricing";
import type { HireOrganizationLayoutMode } from "~/lib/marketplace/hire-organization-layout";
import type { AiEmployeePlanId } from "~/lib/siteglue/ai-employee-plans";
import { cn } from "~/lib/utils";

type HireBuilderHirePanelProps = {
  businessName: string;
  agentName: string;
  selection: HireRecommendationsSelection;
  totalLabel: string;
  isFree: boolean;
  previewReady: boolean;
  /** When false, Onboard CTA stays disabled until Trish finishes the consult. */
  hireEnabled?: boolean;
  isGenerating: boolean;
  isSubmitting: boolean;
  deployedProjectId: string | null;
  accountLabel?: string;
  organizationLayout?: HireOrganizationLayoutMode;
  productLabel?: string;
  siteGluePlanId?: AiEmployeePlanId | null;
  onGeneratePreview?: () => void;
  onHire: () => void;
  className?: string;
};

export function HireBuilderHirePanel({
  businessName,
  agentName,
  selection,
  totalLabel,
  isFree,
  previewReady,
  hireEnabled = true,
  isGenerating,
  isSubmitting,
  deployedProjectId,
  accountLabel,
  organizationLayout,
  productLabel = "Inbound GPT",
  siteGluePlanId = null,
  onGeneratePreview,
  onHire,
  className,
}: HireBuilderHirePanelProps) {
  return (
    <div className={cn("min-h-0 flex-1 overflow-y-auto p-4 sm:p-6", className)}>
      <HireWizardSummaryStep
        businessName={businessName}
        agentName={agentName}
        selection={selection}
        totalLabel={totalLabel}
        isFree={isFree}
        previewReady={previewReady}
        hireEnabled={hireEnabled}
        isGenerating={isGenerating}
        isSubmitting={isSubmitting}
        deployedProjectId={deployedProjectId}
        accountLabel={accountLabel}
        organizationLayout={organizationLayout}
        productLabel={productLabel}
        siteGluePlanId={siteGluePlanId}
        onGeneratePreview={onGeneratePreview}
        onHire={onHire}
      />
    </div>
  );
}
